import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageRoute } from '../../functions/publicMetadataPolicy.js';
import { applyPageMetadata } from '../utils/pageMetadata';

// Reuse the page's existing profile read. Never inspect component content or gates.
export function usePublicPageMetadata(profile, loading, exists = true) {
    const { pathname } = useLocation();
    useEffect(() => {
        const route = getPageRoute(pathname);
        if (!loading && exists && profile && profile.muultiName === route.username) {
            applyPageMetadata(profile, pathname);
        }
    }, [profile, loading, exists, pathname]);
}
